import { Component, Input, ViewEncapsulation } from '@angular/core';

import { BooleanReportParameter } from '../models/boolean-report-parameter';
import { DateRangeReportParameter } from '../models/date-range-report-parameter';

@Component({
    encapsulation: ViewEncapsulation.None,
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        class: 'report-period',
    },
    selector: 'ndt-report-output-date',
    styleUrls: ['./report-output-date.component.scss'],
    templateUrl: './report-output-date.component.html',
    standalone: false
})
export class ReportOutputDateComponent {
   @Input() dateRange: DateRangeReportParameter;

   @Input() dateLabel: string;

   @Input()
   set workDays(workDays: number) {
      this._workDays = workDays;
      this.updateWorkDaysText();
   }

   get workDays(): number {
      return this._workDays;
   }

   private _workDays: number;

   @Input()
   set excludeWeekends(excludeWeekends: BooleanReportParameter) {
      this._excludeWeekends = excludeWeekends;
      this.updateWorkDaysText();
   }

   get excludeWeekends(): BooleanReportParameter {
      return this._excludeWeekends;
   }

   private _excludeWeekends: BooleanReportParameter;

   // eslint-disable-next-line @typescript-eslint/member-ordering
   displayText: string;

   updateWorkDaysText(): void {
      if (this._workDays && this._excludeWeekends) {
         if (this._workDays === 1) {
            this.displayText = '(' + this._workDays + ' work day';
         } else {
            this.displayText = '(' + this._workDays + ' work days';
         }

         if (this._excludeWeekends.value === true) {
            this.displayText += ', excluding weekends';
         }
         this.displayText += ')';
      }
   }
}
